import { Registration } from "./_proxy/entities/registration.entity";


class GlobalValues {
    Registration: Registration;
}

export var Globals = new GlobalValues();